import { Record, Map as ImmutableMap } from 'immutable';
import * as AuthSettingsKeys from 'automation-ui-action-features/actions/webhook/constants/AuthSettingsKeys';
import * as ApiKeyLocations from 'automation-ui-action-features/actions/webhook/constants/ApiKeyLocations';
import setIn from 'immutable-less/transmute/setIn';

// internal nested object not to be exported

export class ApiKeySettings extends Record({
  [AuthSettingsKeys.SECRET_NAME]: null,
  [AuthSettingsKeys.NAME]: null,
  [AuthSettingsKeys.LOCATION]: ApiKeyLocations.HEADER
}, 'ApiKeySettings') {}
export default class AuthSettings extends Record({
  [AuthSettingsKeys.AUTH_SCHEME]: 'APIKEY',
  [AuthSettingsKeys.API_KEY_SETTINGS]: new ApiKeySettings()
}, 'AuthSettings') {
  constructor(props) {
    let propsMap = ImmutableMap(props);
    const apiKeySettings = new ApiKeySettings(propsMap.get(AuthSettingsKeys.API_KEY_SETTINGS));
    propsMap = propsMap.set(AuthSettingsKeys.API_KEY_SETTINGS, apiKeySettings);
    super(propsMap);
  }
  getSecretName() {
    return this.getIn([AuthSettingsKeys.API_KEY_SETTINGS, AuthSettingsKeys.SECRET_NAME]);
  }
  setSecretName(secretName) {
    return setIn([AuthSettingsKeys.API_KEY_SETTINGS, AuthSettingsKeys.SECRET_NAME], secretName, this);
  }
  getName() {
    return this.getIn([AuthSettingsKeys.API_KEY_SETTINGS, AuthSettingsKeys.NAME]);
  }
  setName(name) {
    return setIn([AuthSettingsKeys.API_KEY_SETTINGS, AuthSettingsKeys.NAME], name, this);
  }
  getLocation() {
    return this.getIn([AuthSettingsKeys.API_KEY_SETTINGS, AuthSettingsKeys.LOCATION]);
  }
  setLocation(location) {
    return setIn([AuthSettingsKeys.API_KEY_SETTINGS, AuthSettingsKeys.LOCATION], location, this);
  }
  locationIsQueryParams() {
    return this.getLocation() === ApiKeyLocations.QUERY_PARAM;
  }
  isEmpty() {
    return !this.getName() && !this.getSecretName();
  }
}